import React from 'react';
import { Button } from '../../ui/Button';
import { RepHeader } from '../RepHeader';
import { ArrowRight, Lock, Zap, ShieldCheck } from '../../ui/Icons';

export function StepHook({ onNext }) {
  return (
    <div className="flex flex-col items-center text-center max-w-3xl mx-auto pt-8 md:pt-16 space-y-10">
      <RepHeader />
      
      <div className="space-y-6">
        <h1 className="font-heading text-5xl md:text-7xl font-extrabold tracking-tight leading-tight">
          Find Your Next Vehicle in <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-blue to-blue-400">Under 60 Seconds</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed">
          Personalized recommendations, real trade-in values, and pre-approval — without leaving your couch.
        </p>
      </div>

      <div className="w-full max-w-md mx-auto space-y-4">
        <Button onClick={onNext} className="h-16 text-lg group">
          Start My Vehicle Search
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </Button>
        <p className="text-sm text-gray-500">60 seconds. No spam. No pressure.</p>
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-gray-400 pt-8 border-t border-white/5 w-full">
        <span className="flex items-center gap-2"><Lock size={16} className="text-blue-400" /> Secure & Private</span>
        <span className="flex items-center gap-2"><Zap size={16} className="text-yellow-400" /> Instant Trade Value</span>
        <span className="flex items-center gap-2"><ShieldCheck size={16} className="text-emerald-400" /> No Credit Pull</span>
      </div>
    </div>
  );
}